<template>
  <div class="home" ref="info">
    <el-carousel :height="bannerHeight + 'px'">
      <el-carousel-item v-for="item in imgArr" :key="item">
        <img class="header-banner" :src="item" alt="banner" style="width: 100%" />
      </el-carousel-item>
      <div class="nav-header">
        <!-- <img src="../assets/nav.png" alt="" /> -->
        <div>芜湖数投方拓信息科技有限公司</div>
        <ul>
          <li>
            <a href="javascript:void(0)" @click="scrollClick('1')">关于我们</a>
          </li>
          <li>
            <a href="javascript:void(0)" @click="scrollClick('2')">联系我们</a>
          </li>
        </ul>
      </div>
    </el-carousel>

    <div class="content" ref="aboutDom">
      <el-row>
        <el-col :span="20" :offset="2">
          <div class="about-bg">关于我们</div>
          <img src="../assets/abouts-img.png" alt="abouts" />
          <div class="describe">
            <img src="../assets/company.png" alt="company" />
            <div class="describe-content">
              <p>芜湖数投方拓信息科技有限公司，统一社会信用代码：91340203MA8P1KTRX6，成立于2022-05-16，注册资本2000万元。</p>
              <p>公司主营业务是一家受持牌保险机构委托，为保险公司销售保险产品提供稳定的系统支持及营销推广服务及数据传输等技术服务。</p>
              <p>
                系统服务主要内容包含提供实时数据对接，数据传输；提供信息存储，试算功能；为合作方提供客户的访问转接服务；定期进行系统优化或维护的服务；公司为了扩展业务规模，与多家渠道方进行合作，在提供稳定的系统基础上，同时也为合作平台进行信息宣传和推广等服务。
              </p>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <!-- <el-col :span="20" :offset="2">
          <div class="chat">
            <a href="javascript:void(0)" @click="dialogShowClick"><img src="../assets/chat.png"></a>
          </div>
        </el-col>      -->

        <el-col :span="20" :offset="2">
          <el-carousel class="chat" :height="productHeight + 'px'" :interval="3500">
            <el-carousel-item v-for="(item, index) in newProductImgList" :key="index">
              <img :src="item.bannerUrl" alt="product" @click="dialogShowClick(item)" />
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>

      <div class="map" ref="callDom">
        <div class="white-height"></div>
        <div class="call-me">联系我们</div>
        <p>
          <img src="../assets/company-footer.png" alt="footer" />
          <span>公司名称：芜湖数投方拓信息科技有限公司</span>
        </p>
        <p style="margin-right: 170px">
          <img src="../assets/company-footer.png" alt="footer" />
          <span>邮政编码：241000</span>
        </p>
      </div>
      <div class="footer">
        <p>
          芜湖数投方拓信息科技有限公司 版权所有
          <!-- 版权所有 © 2018 <a href="https://beian.miit.gov.cn" target="_blank"
            class="footer-link">京ICP备18064248号-1</a> -->
        </p>
      </div>
    </div>

    <!-- 信息采集弹窗 -->
    <el-dialog title="请填写基本信息" :visible.sync="dialogVisible" center width="720px">
      <el-form label-position="left" label-width="80px" :rules="rules" ref="formLabelAlign" :model="formLabelAlign">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formLabelAlign.name" placeholder="请输入您的姓名" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCardNo">
          <el-input v-model="formLabelAlign.idCardNo" placeholder="请输入您的身份证号码" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNo">
          <el-input v-model="formLabelAlign.phoneNo" placeholder="请输入您的手机号" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="formLabelAlign.code" placeholder="请输入验证码" maxlength="6"></el-input>
          <button @click.prevent="getIdentifyingCode" class="code-btn" :disabled="!codeFlag">
            <span v-show="codeFlag">获取验证码</span>
            <span v-show="!codeFlag" class="count">{{ count }}s</span>
          </button>
        </el-form-item>
        <el-radio v-model="radio" label="1">
          请阅读并同意<a href="javascript:void(0)" class="radio-a" @click.stop="dialogAnnexVisible = true">《个人隐私保护政策》</a>
        </el-radio>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('formLabelAlign')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 个人隐私保护政策 -->
    <div class="dialog-footer">
      <el-dialog title="个人隐私保护政策" :visible.sync="dialogAnnexVisible" center :show-close="false" width="720px"
        class="annex-dialog">
        <div class="annex-content" v-html="annexContent"></div>
        <span slot="footer">
          <el-button @click="dialogAnnexVisible = false">取 消</el-button>
          <el-button type="primary" @click="annexConfirmClick">同 意</el-button>
        </span>
      </el-dialog>
    </div>
    <PopUp v-if="link" :link="link" @close="link = ''" />
  </div>
</template>

<script>
import axios from "axios";
import PopUp from "../components/PopUp";
export default {
  name: "Home",
  components: { PopUp },
  data() {
    return {
      link: "",
      imgArr: [
        require("../assets/banner1.png"),
        require("../assets/banner2.png"),
      ],
      productImgList: [
        require("../assets/chat.png"),
        require("../assets/zxes.png"),
        require("../assets/zaddbwpb.png"),
        require("../assets/hn.png"),
        require("../assets/pets.png"),
        require("../assets/ejia.png"),
        require("../assets/bwwy.png"),
        require("../assets/bwyl.png"),
      ],
      newProductImgList: [],
      dialogVisible: false,
      formLabelAlign: {
        name: "",
        idCardNo: "",
        phoneNo: "",
        code: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idCardNo: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        phoneNo: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      codeFlag: true,
      count: 60,
      bannerHeight: 0,
      productHeight: 0,
      timer: null,
      radio: "0",
      dialogAnnexVisible: false,
      annexContent:
        '<p style="text-align: center;">自然印象官网隐私声明</p>\
          <p>尊敬的用户：</p>\
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京自然印象技术有限公司及旗下为您提供相关服务的&nbsp;等平台（以下统称&ldquo;<strong>自然印象</strong>&rdquo;或&ldquo;<strong>我们</strong>&rdquo;）非常重视客户个人信息及隐私权的保护，我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺采取相应的安全保护措施来保护您的个人信息。因此我们制订了涵盖如何收集、存储、使用、共享和保护客户信息的<strong>《隐私声明》（以下简称&ldquo;本隐私声明&rdquo;或&ldquo;本声明&rdquo;）</strong>。</p>\
          <p><strong>本隐私声明适用于本平台。如您使用</strong><strong>自然印象</strong><strong>提供的某项或某几项服务有其单独的隐私声明的，该等服务对应的隐私声明将与本隐私声明一起构成一份完整的隐私声明。</strong></p>\
          <p><span style="text-decoration:underline;"><strong>需要特别说明的是，本隐私声明不适用于其他第三方向您提供的服务，也不适用于</strong><strong>北京自然印象技术有限公司</strong><strong>和/或其关联公司已另行独立设置隐私声明的产品及/或服务。</strong></span></p>\
          <p><span style="text-decoration:underline;"><strong>在使用我们各项产品及/或服务前，请您务必仔细阅读并透彻理解本隐私声明，特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。</span></strong><strong>阅读过程中，如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</strong></p>\
          <p>邮箱：parter@zryxqkl.com</p>\
          <p><strong>如您不同意协议中的任何条款，您应立即停止访问或使用相关服务。</strong></p>\
          <p><strong>&nbsp;</strong></p>\
          <p><strong>术语与定义</strong></p>\
          <p><strong>本平台：</strong>指名称为自然印象域名为<a href="http://www.zryxqkl.com" target="_blank">www.zryxqkl.com</a>的网站。</p>\
          <p><strong>个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</strong></p>\
          <p><strong>个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等（我们将在本隐私声明中对具体个人敏感信息以粗体进行显著标识）。</strong></p>\
          <p><strong>关联公司：</strong>指一方现在或将来控制、共同控制另一方或对另一方施加重大影响,以及两方或两方以上现在或将来同受一方控制、共同控制或重大影响的任何公司、机构以及上述公司或机构的法定代表人。&ldquo;控制&rdquo;是指有权决定一个企业或机构的财务和经营政策,并能据以从该企业或机构的经营活动中获取利益。&ldquo;重大影响&rdquo;是指对一个企业或机构的财务和经营政策有参与决策的权力,但并不能够控制或者与其他方一起共同控制这些政策的制定。</p>\
          <p><strong>&nbsp;</strong></p>\
          <p><strong>本隐私声明将帮助您了解以下内容：</strong></p>\
          <p>一、&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们如何收集和使用您的个人信息</p>\
          <p>二、&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们如何使用&nbsp;<strong>Cookie</strong>&nbsp;和同类技术</p>\
          <p>三、&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们如何共享、转让、公开披露您的个人信息</p>\
          <p>四、&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们如何保护和保存您的个人信息</p>\
          <p>五、&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您如何管理您的个人信息</p>\
          <p>六、&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们如何处理未成年人的个人信息</p>\
          <p>七、&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通知和修订</p>\
          <p>八、&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如何联系我们</p>\
          <p>&nbsp;</p>\
          <p><strong>一、我们如何收集和使用您的个人信息</strong></p>\
          <p>（一）您的个人信息收集的规则</p>\
          <p>在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：</p>\
          <p><strong>1.核心业务功能：</strong>为本隐私声明之目的，我们仅会出于以下核心业务功能，收集和使用您的个人信息，<strong>该等核心业务功能是为了向您提供我们产品及/或服务的基本功能。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务。</strong></p>\
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;帮助您成为我们的注册用户</p>\
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为帮助您注册成为我们的用户，以便我们为您提供用户服务，您需要提供手机号码、客户编号用于创建本平台账户。</p>\
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对于需要通过本平台用户账户才能使用的服务，我们可能会根据您提供的上述信息校验您的用户身份，确保我们是在为您本人提供服务。</p>\
          <p><strong>2.附加业务功能：</strong>为使您使用我们的产品和/或服务更便捷或更有乐趣，从而提升您的用户体验，我们的以下附加功能中可能会收集和使用您的个人信息。<strong>如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的核心业务功能。</strong></p>\
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;改进我们的产品及/或服务：为了提供服务及改进服务质量的合理需要，我们可能会获得的您的其它信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联公司、我们合作伙伴之间进行互动时授权我们获得的相关信息。</p>\
          <p><strong>3.其它</strong></p>\
          <p><strong>（1）若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。</strong></p>\
          <p>（2）若我们将信息用于本声明未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。</p>\
          <p>（二）我们从第三方获得您个人信息的情形</p>\
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们可能从第三方获取您授权共享的账户信息（头像、昵称），并在您同意本隐私声明后将您的第三方账户与您的自然印象账户绑定，使您可以通过第三方账户直接登录并使用我们的产品及/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</p>\
          <p><strong>（三）征得授权同意的例外</strong></p>\
          <p><strong>您充分知晓，以下情形中，我们收集、使用个人信息可能无需征得您的授权同意：</strong></p>\
          <p><strong>1.与国家安全、国防安全直接相关的；</strong><br />\
          <strong>2.与公共安全、公共卫生、重大公共利益直接相关的；</strong><br />\
          <strong>3.与犯罪侦查、起诉、审判和判决执行等直接相关的；</strong><br />\
          <strong>4.法律法规规定的其他情形。</strong></p>\
          <p><strong>（四）您个人信息使用的规则</strong></p>\
          <p>1.我们会根据本隐私声明的约定，在实现我们的产品及/或服务功能所必要的范围内，对所收集的个人信息进行使用。</p>\
          <p>2.在收集您的个人信息后，我们可能将通过技术手段对部分数据进行匿名化处理，匿名化处理的信息将无法识别主体。<strong>请您了解并同意，在此情况下我们有权使用已经匿名化的信息，并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</strong></p>\
          <p><strong>3.请您注意，您在使用我们的产品及/或服务时所提供的所有个人信息，除非您删除、通过系统设置或联系我们等方式撤回您的同意，否则将在您使用我们的产品及/或服务期间持续授权我们使用。在您注销账户时，我们将停止使用并删除您的个人信息。</strong></p>\
          <p>4.我们会对我们的产品及/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品及/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</p>\
          <p>5.当我们要将您的个人信息用于本隐私声明未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过请求您主动勾选的形式事先征求您的同意。</p>\
          <p><strong>（五）您理解并同意：</strong></p>\
          <p><strong>1.我们致力于打造多样的产品及/或服务以满足您的需求。因我们向您提供的产品及/或服务种类众多，且不同用户选择使用的具体产品及/或服务范围存在差异，相应的，基本/附加功能及收集使用的个人信息类型、范围等会有所区别，请以具体的产品及/或服务功能为准；</strong></p>\
          <p><strong>2.为给您带来更好的产品及/或服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的及方式。对此，我们将通过更新本隐私声明，以弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。</strong></p>\
          <p><strong>在此过程中，如果您有任何疑问、意见或建议的，您可通过我们提供的各种联系方式与我们联系，我们会尽快为您做出解答。</strong></p>\
          <p><strong>二、我们如何使用Cookie和同类技术</strong></p>\
          <p><strong>（一）Cookie的使用</strong></p>\
          <p>1.为实现您联机体验的个性化需求，使您获得更轻松的访问体验，我们会在您的计算机或移动设备上发送一个或多个名为<strong>Cookie</strong>的小数据文件，指定给您的<strong>Cookie</strong>是唯一的，它只能被将<strong>Cookie</strong>发布给您的域中的<strong>Web</strong>服务器读取。我们向您发送<strong>Cookie</strong>是为了简化您重复登录的步骤、存储您的偏好或您浏览历史等数据进而为您提供偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账户或数据安全。</p>\
          <p>2.我们不会将&nbsp;<strong>Cookie</strong>用于本隐私声明所述目的之外的任何用途。您可根据自己的偏好管理或删除<strong>Cookie</strong>。您可以清除计算机上保存的所有<strong>Cookie</strong>，大部分网络浏览器会自动接受<strong>Cookie</strong>，但您通常可根据自己的需要来修改浏览器的设置以拒绝<strong>Cookie</strong>；另外，您也可以清除软件内保存的所有<strong>Cookie</strong>。但如果您这么做，您可能需要在每一次访问我们的网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。</p>\
          <p><strong>三、我们如何共享、转让、公开披露您的个人信息</strong></p>\
          <p><strong>（一）共享</strong></p>\
          <p><strong>1.我们不会与</strong><strong>自然印象</strong><strong>以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</strong></p>\
          <p><strong>（1）在法定情形下的共享：</strong>我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>\
          <p><strong>（2）在获取明确同意的情况下共享：</strong>获得您的明确同意后，我们会与其它方共享您的个人信息。</p>\
          <p><strong>（3）在您主动选择情况下共享：某些产品及/或服务可能由第三方提供或由相关服务提供方与第三方共同提供，因此，只有在经您授权后，共享您的信息，第三方才能为您提供您需要的产品及/或服务。</strong></p>\
          <p>您通过自然印象&nbsp;购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易及售后服务需求。</p>\
          <p><strong>（4）与关联公司间共享：经您授权后，我们可能会将您的个人信息与我们的关联公司共享。我们只会共享必要的个人信息，并要求关联公司以不低于本隐私声明水平的方式保护您的个人信息。我们的关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</strong></p>\
          <p><span style="text-decoration:underline;"><strong>为便于我们基于</strong><strong>自然印象&nbsp;</strong><strong>账户向您提供产品及/或服务，推荐您可能感兴趣的信息，识别会员账号异常，保护</strong><strong>自然印象&nbsp;</strong><strong>关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司和/或其指定的服务提供商共享。</span></strong>我们只会共享必要的个人信息，且受本隐私声明中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。</p>\
          <p><strong>就上述关联公司向您提供的服务，我们对该等关联公司提供的服务性质与质量不作任何承诺或承担任何责任，对该等关联公司独立进行的用户信息采集和处理行为也不作任何承诺或承担任何责任。有关您在使用关联公司服务中相关的隐私控制和选项，以及服务提供者的隐私规定，请您谨慎参阅该等关联公司所提供的隐私声明。</strong></p>\
          <p><strong>（5）与授权合作伙伴共享：</strong><span style="text-decoration:underline;"><strong>我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，</span></strong>我们仅会出于本隐私声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。</p>\
          <p>我们的合作伙伴包括以下类型：</p>\
          <p>供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。</p>\
          <p>我们会对授权合作伙伴获取有关信息的应用程序接口<strong>（API）</strong>、软件工具开发包<strong>（SDK）</strong>进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私声明以及其他任何相关的保密和安全措施来处理个人信息。</p>\
          <p>在将信息提供给第三方前，我们会审慎评估该第三方收集信息的合法性、正当性、必要性。有关您在使用第三方服务中相关的隐私控制和选项，以及服务提供者的隐私规定，请您谨慎参阅该等第三方所提供的隐私声明。</p>\
          <p>2．对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明以及其他任何相关的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。</p>\
          <p><strong>（二）转让</strong></p>\
          <p><strong>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</strong></p>\
          <p>1.在获取明确同意的情况下转让：获得您的明确同意后，我们会向其它方转让您的个人信息；</p>\
          <p>2.在本产品及/或服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本声明的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</p>\
          <p><strong>（三）公开披露</strong></p>\
          <p><strong>我们仅会在以下情况下，公开披露您的个人信息：</strong></p>\
          <p>1.获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</p>\
          <p>2.<span style="text-decoration:underline;">如果我们确定您出现违反法律法规或严重违反本产品及/或服务相关协议及规则的情况，或为保护本产品及/或服务及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或本产品及/或服务相关协议规则征得您同意的情况下披露关于您的个人信息，</span>包括相关违规行为以及本产品及/或服务已对您采取的措施。</p>\
          <p><strong>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</strong></p>\
          <p><strong>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</strong></p>\
          <p>1.与国家安全、国防安全直接相关的；</p>\
          <p>2.与公共安全、公共卫生、重大公共利益直接相关的；</p>\
          <p>3.与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>\
          <p>4.<strong>法律法规规定的其他情形。</strong></p>\
          <p>请知悉，根据适用的法律，若我们<span style="text-decoration:underline;"><strong>对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意</strong></span>。</p>\
          <p>&nbsp;</p>\
          <p><strong>四、我们如何保护和保存您的个人信息</strong></p>\
          <p><strong>（一）我们保护您个人信息的技术与措施</strong></p>\
          <p>我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：</p>\
          <p><strong>1.数据安全技术措施</strong></p>\
          <p>我们采取安全技术和管理措施来防止您的个人信息遭到未经授权访问使用、公开披露、使用、修改、损坏或丢失，包括但不限于：</p>\
          <p>（1）我们采取双因子认证、多因子认证对用户个人信息进行保存，并通过隔离技术进行隔离。在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换在内多种数据脱敏技术增强个人信息在使用中安全性。</p>\
          <p>（2）我们采取严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。</p>\
          <p>（3）我们采取数据访问日志分析技术进行个人信息安全审计。</p>\
          <p><strong>2.数据安全制度措施</strong></p>\
          <p>（1）我们制定了安全保障制度，规范我们各部门对个人信息所采取的管理措施。</p>\
          <p>（2）我们存储您个人数据的系统得到了相应的安全和服务认证，如通过公安部安全等级保护测评。</p>\
          <p>（3）我们会定期举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>\
          <p>（4）我们严格管理访问权限，对被授权访问您的个人信息的人员，实施最小授权的访问控制策略，使其只能访问职责所需的最小必要的个人信息，且仅具备完成职责所需的最少的数据操作权限。</p>\
          <p>3.互联网并非绝对安全的环境，使用本平台服务时，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>\
          <p>4.请使用复杂密码，协助我们保证您的账号安全。同时请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</p>\
          <p><strong>5.安全事件处置</strong></p>\
          <p>（1）我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。</p>\
          <p>（2）在不幸发生个人信息安全事件后，我们将按照法律法规的要求启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>\
          <p>6.如果您发现自己的个人信息泄密或我们存在有安全弱点、可疑安全事件时，尤其是您的账户及密码发生泄露，请您立即通过本隐私声明约定的联系方式联络我们，以便我们采取相应措施，<strong>禁止私自尝试或验证弱点</strong>。</p>\
          <p>7.如果您对我们的个人信息保护有任何疑问，可通过我们在<strong>本隐私声明中提供的联系方式</strong>联系我们。</p>\
          <p><strong>（二）您个人信息的保存</strong></p>\
          <p>1.您的个人信息将会被存储于中华人民共和国境内。如基于其它必要的业务需要确需将您的个人信息传输至境外，我们会单独征得您的授权同意并要求接收方按照我们的说明、本隐私声明以及其他任何相关的保密和安全措施来处理这些个人信息。</p>\
          <p>2.若您成功申请注销本平台账户，我们将对您的账户注销申请进行审核。审核通过后，我们将对您的个人信息进行删除或匿名化处理。</p>\
          <p>3.<strong>如果我们终止服务或运营，我们会至少提前30日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</strong></p>\
          <p><strong>五、您如何管理您的个人信息</strong></p>\
          <p>我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</p>\
          <p><strong>（一）查询、更正和补充您的个人信息</strong></p>\
          <p>除法律法规规定外，您有权通过以下方式查询、更正和补充您的个人信息，具体包括：</p>\
          <p>查询或更正手机号：进入自然印象&nbsp;-点击&ldquo;我的&rdquo;-点击&ldquo;个人中心&rdquo;-点击&ldquo;修改手机号&rdquo;进行信息查询或更正。</p>\
          <p><strong>（二）删除您的个人信息</strong></p>\
          <p>1.用户删除个人信息的方法和路径</p>\
          <p>进入自然印象&nbsp;-点击&ldquo;我的&rdquo;-点击&ldquo;个人中心&rdquo;-点击&ldquo;删除个人信息&rdquo;。</p>\
          <p>2.在以下情形中，您可以向我们提出删除个人信息的请求：</p>\
          <p>（1）如果我们处理个人信息的行为违反法律法规；</p>\
          <p>（2）如果我们收集、使用您的个人信息，却未征得您的同意；</p>\
          <p>（3）如果我们处理个人信息的行为违反了与您的约定；</p>\
          <p>（4）如果您注销了账户；</p>\
          <p>（5）如果我们终止服务及运营。</p>\
          <p>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>\
          <p><strong>（三）改变您授权同意的范围或撤回您的授权</strong></p>\
          <p><strong>您可以通过删除信息、关闭设备功能、在设备系统中进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集、处理您个人信息的全部授权。</strong></p>\
          <p><strong>请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</strong></p>\
          <p><strong>（四）注销账户</strong></p>\
          <p>1.您随时可注销此前注册的账户，您可以通过以下方式自行操作：进入自然印象&nbsp;-点击&ldquo;我的&rdquo;-点击&ldquo;注销账户&rdquo;。</p>\
          <p>2.在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</p>\
          <p><strong>（五）如果您不想接受我们给您发送的促销信息，您随时可通过以下方式取消：</strong></p>\
          <p><strong>无。</strong></p>\
          <p><strong>（六）响应您的请求</strong></p>\
          <p>1.如果您无法通过上述方式查询、更正、补充或删除您的个人信息，或您需要查询、更正、补充或删除您在使用我们产品及/或服务时所产生的其他个人信息，或您认为我们存在任何违反法律法规或与您关于个人信息的收集或使用的约定，可通过我们在本隐私声明中提供的联系方式联系我们。</p>\
          <p>2.为了保障安全，我们可能需要您提供书面请求，或以其它方式证明您的身份，我们将在收到您反馈并验证您的身份后的<strong>30</strong>天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>\
          <p><strong>3.在以下情形中，按照法律法规要求，我们将可能无法响应您的请求：</strong></p>\
          <p><strong>（1）与国家安全、国防安全直接相关的；</strong></p>\
          <p><strong>（2）与公共安全、公共卫生、重大公共利益直接相关的；</strong></p>\
          <p><strong>（3）与犯罪侦查、起诉、审判和执行判决等直接相关的；</strong></p>\
          <p><strong>（4）有充分证据表明您存在主观恶意或滥用权利的；</strong></p>\
          <p><strong>（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</strong></p>\
          <p><strong>（6）涉及商业秘密的。</strong></p>\
          <p><strong>&nbsp;</strong></p>\
          <p><strong>六、我们如何处理未成年人的个人信息</strong></p>\
          <p>1.请父母或监护人指导未成年人使用我们的服务。我们将根据国家相关法律法规的规定保护未成年人的信息的保密性及安全性。</p>\
          <p>2．如您为未成年人，建议请您的父母或监护人阅读本声明，并在征得您父母或监护人同意的前提下使用我们的产品及/或服务或向我们提供您的信息。如您的监护人不同意您按照本声明使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。</p>\
          <p>3．如您为未成年人的父母或监护人，当您对您所监护的未成年人的信息处理存在疑问时，请通过本声明提到的联系方式联系我们。</p>\
          <p><strong>七、通知和修订</strong></p>\
          <p>1.为给您提供更好的服务以及随着业务的发展，本隐私声明也会随之更新。但未经您明确同意，我们不会削减您依据本隐私声明所应享有的权利。我们会通过在本平台上发出更新版本并在生效前以适当方式提醒您相关内容的更新，也请您及时了解最新的隐私声明。</p>\
          <p>2.对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私声明的具体变更内容）。</p>\
          <p><strong>3.本隐私声明所指的重大变更包括但不限于：</strong></p>\
          <p><strong>（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</strong></p>\
          <p><strong>（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</strong></p>\
          <p><strong>（3）个人信息共享、转让或公开披露的主要对象发生变化；</strong></p>\
          <p><strong>（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</strong></p>\
          <p><strong>（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</strong></p>\
          <p><strong>（6）个人信息安全影响评估报告表明存在高风险。</strong></p>\
          <p>&nbsp;</p>\
          <p><strong>八、如何联系我们</strong></p>\
          <p>1.如您对本隐私声明或您个人信息的相关事宜有任何问题、意见或建议，请通过我们在本隐私声明中提供的联系方式联系我们。</p>\
          <p>2.&nbsp;一般情况下，我们将在三十天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报，或者向有管辖权的法院提起诉讼。</p>\
          <p>&nbsp;</p>\
          <p>&nbsp;</p>\
          <p><strong>我们谨此再次提醒您，本隐私声明内容中以加粗方式显著标识的条款，请您着重阅读。</strong></p>\
          <p><strong>您点击&ldquo;同意&rdquo;按钮，勾选&ldquo;同意隐私声明&rdquo;选框，或登录本平台均视为您完全接受本隐私声明，在操作之前请您再次确认已知悉并完全理解本隐私声明的全部内容。</strong></p>\
          <p>&nbsp;</p>',
    };
  },
  mounted() {
    this.imgload();
    this.getData();
    window.addEventListener(
      "resize",
      () => {
        this.screenWidth = window.innerWidth;
        this.imgload();
      },
      false
    );
  },
  methods: {
    getData() {
      axios
        .post("/api/zaib/zryx/banner/query/list", {
          page: 1,
          size: 9999,
          data: {},
        })
        .then((res) => {
          if (res.data?.respCode === "0000") {
            let list = res.data?.data?.filter((item) => item.status === "1");
            this.newProductImgList = list.sort((a, b) => a.sort - b.sort) || [];
          }
        });
    },
    imgload() {
      this.$nextTick(() => {
        this.bannerHeight = (715 / 1440) * window.innerWidth;
        this.productHeight = (439 / 1296) * window.innerWidth;
      });
    },
    scrollClick(val) {
      if (val === "1")
        this.$refs.aboutDom.scrollIntoView({ behavior: "smooth" });
      else this.$refs.callDom.scrollIntoView({ behavior: "smooth" });
    },
    dialogShowClick(item) {
      if (item.bannerJump === "1") {
        if (item.jumpUrl) {
          window.open(item.jumpUrl);
        } else {
          this.link = item.jumpBannerUrl;
        }
      }
      // this.dialogVisible = true
      // this.radio = '0'
      // // 清空验证码信息
      // this.codeFlag= true
      // clearInterval(this.timer)
      // this.timer = null
      // this.$refs['formLabelAlign'].resetFields()
    },
    // 获取验证码
    getIdentifyingCode() {
      if (!this.timer) {
        this.count = 60;
        this.codeFlag = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.codeFlag = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 查看个人信息保护政策
    annexConfirmClick() {
      this.dialogAnnexVisible = false;
      this.radio = "1";
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.radio === "1") {
            this.dialogVisible = false;
            this.$message({
              message: "基本信息录入成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "请阅读并同意《个人隐私保护政策》",
              type: "warning",
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "./style/Home";
</style>
